/** Direct customer changes must respect the same locks as conflict repair.
 * Custom dimension fields inherit their owning option's lock. */
export function isLockedOptionField(
  options: ReadonlyArray<{ id: string; locked?: boolean }>,
  field: string,
): boolean {
  const exact = options.find((option) => option.id === field);
  if (exact) return exact.locked === true;
  return options.some((option) => option.locked === true
    && (field === `${option.id}_width` || field === `${option.id}_height`));
}
